import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  HeaderWrapper,
  HamburgerButton,
  Drawer,
  DrawerMenu,
  DrawerOverlay,
  NavItem,
  NavLink,
  DropdownMenu,
  DropdownItem,
  Divider,
  HorizontalDivider
} from './HeaderStyles';
import useDecodeHtml from '../../hooks/useDecodeHtml';
import SocialIcons from '../SocialIcons/SocialIcons';
import { useNavigate } from "react-router-dom";
import { useCategories } from '../../api/fetchExampleData'

const Header = () => {
  const { data } = useCategories();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1100);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768);
  const decodeHtml = useDecodeHtml();
  const navigate = useNavigate();

  // Update layout based on window size
  const updateMedia = () => {
    setIsDesktop(window.innerWidth > 1100);
    setIsTablet(window.innerWidth > 768);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };


  const handleMouseEnter = (index) => {
    setActiveDropdown(index);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const logo = "https://rossomotori.it/wp-content/uploads/2025/03/home-page.png";

  return (
    <>
      <HeaderWrapper>
        {(isTablet || isDesktop) ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <img src={logo} alt={"logo"} width={"30%"} height={"30%"} onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {data?.map((item, index) => (
                  <NavItem
                    key={index}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <NavLink to={item.url}>{decodeHtml(item.name)}</NavLink>
                    {item.subcategories && item.subcategories.length > 0 && (
                      <DropdownMenu show={activeDropdown === index}>
                        {item.subcategories.map((sub, subIndex) => (
                          <DropdownItem key={subIndex} to={sub.url}>
                            {sub.name}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    )}
                  </NavItem>
                ))}
                {isDesktop && (
                  <>
                    <Divider />
                    <SocialIcons />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Link to='/'>
                  <img src={logo} alt="Logo" width={'90%'} height="30" />
                </Link>
              </div>
              <HamburgerButton onClick={toggleDrawer}>
                <FaBars style={{ color: 'black' }} />
              </HamburgerButton>
              <Drawer open={drawerOpen}>
                <DrawerMenu>
                  <div>
                    <Link to={'/'} onClick={toggleDrawer} style={{ fontWeight: 'bold' }}>
                      <p style={{ margin: '15px 0 20px' }}>Home</p>
                    </Link>
                    <Link to={'/team'} onClick={toggleDrawer} style={{ fontWeight: 'bold' }}>
                      <p style={{ margin: '15px 0px 20px' }}>Chi siamo</p>
                    </Link>
                    <Link to={'/contact-us'} onClick={toggleDrawer} style={{ fontWeight: 'bold' }}>
                      <p style={{ margin: '15px 0px 20px' }}>Contattaci</p>
                    </Link>
                    <HorizontalDivider />
                  </div>
                  {data?.map((item, index) => (
                    <div key={index} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Link to={item.url} onClick={toggleDrawer} style={{ fontWeight: 'bold' }}>
                        <p>{decodeHtml(item.name)}</p>
                      </Link>
                      {item.subcategories && item.subcategories.length > 0 && (
                        <div>
                          {item.subcategories.map((sub, subIndex) => (
                            <Link to={sub.url} key={subIndex} onClick={toggleDrawer}>
                              <p style={{ marginTop: '0.7rem', marginLeft: '0.5rem', fontSize: '1rem' }}>
                                {sub.name}
                              </p>
                            </Link>
                          ))}
                        </div>
                      )}
                      <HorizontalDivider />
                    </div>
                  ))}
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5rem' }}>
                    <SocialIcons />
                  </div>
                  <div style={{ display: 'flex', textAlign: 'center', marginTop: '0.5rem', flexDirection: 'column' }}>
                    <p style={{ margin: 0 }}>© 2025 Rossomotori.it</p>
                    <p style={{ margin: 0 }}>Tutti i diritti riservati.</p>
                    <Link to='https://www.linkedin.com/in/andreafrangeamore/' style={{ textDecoration: 'none' }}>
                      <p style={{ margin: '15px 0 10px' }}>Sviluppato da Andrea Frangeamore 👨‍💻</p>
                    </Link>
                  </div>
                </DrawerMenu>
              </Drawer>
              {drawerOpen && <DrawerOverlay onClick={toggleDrawer} />}
            </div>
          </>
        )}
      </HeaderWrapper>
    </>
  );
};

export default Header;
